import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ImpersonationTokenHolder } from 'app/core/auth/impersonation-token.holder';
import { KeycloakService } from 'keycloak-angular';
import { EMPTY, Observable, catchError, from, of, switchMap } from 'rxjs';

let isLoggingOut = false;

const forceLogout = (keycloackService: KeycloakService): void => {
    if (isLoggingOut) return;
    isLoggingOut = true;
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessToken');
    keycloackService.logout();
};

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const keycloackService = inject(KeycloakService);

    if (req.url.includes('evolus')) {
        return next(req.clone());
    }

    if (keycloackService.isLoggedIn()) {
        return of(true).pipe(
            switchMap(() => {
                const impersonatedToken = ImpersonationTokenHolder.token;
                if (impersonatedToken) {
                    return of(impersonatedToken);
                }
                if (keycloackService.isTokenExpired(60)) {
                    return from(keycloackService.updateToken()).pipe(
                        switchMap(() => keycloackService.getToken()),
                        catchError(() => {
                            // Refresh token also expired — clean logout instead of leaving user stuck on 401s
                            forceLogout(keycloackService);
                            return EMPTY;
                        })
                    );
                }
                return keycloackService.getToken();
            }),
            switchMap((token) => {
                const authedReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
                return next(authedReq);
            })
        );
    }

    return next(req.clone());
};
